import { Modal } from "antd";
import { useParams } from "react-router-dom";
import { useCompleteDelivery } from "../../api/api";

export default function ConfirmDeliveryModal({
  deliveryId,
  open,
  onCancel,
  onError,
  onSuccess,
}: {
  onSuccess: () => void;
  onError: () => void;
  deliveryId?: string;
  open: boolean;
  onCancel: () => void;
}) {
  const { id } = useParams();
  const { mutateAsync: completeDeliveryAsync, isPending } =
    useCompleteDelivery(id);

  const handleDropComplete = () => {
    completeDeliveryAsync({ deliveryId: deliveryId! })
      .then(() => {
        onSuccess();
      })
      .catch(onError);
  };

  return (
    <Modal
      title="Confirm Drop?"
      open={open}
      onOk={() => handleDropComplete()}
      onCancel={() => {
        onCancel();
      }}
      okText={"Confirm"}
      okButtonProps={{
        loading: isPending,
        disabled: isPending,
      }}
    >
      Are you sure you would like to mark this delivery as COMPLETE?
    </Modal>
  );
}
